import { ActionType } from 'src/types/common/common';
import { ResponsiveCarouselAdaptor } from 'src/constrains/DraggableModules/Components';

const ResponsiveProductCarouselFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnCarouselItemReselect = (id, products) => {
    // const _n = optionsToNum[posterType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: products });
    }
  };

  const handleOnCarouselItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    //console.log(123123123123123);
    //console.log('typedata', data);
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  return {
    handleOnCarouselItemReselect,
    handleOnCarouselItemDelete,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  };
};
const generateResponsiveProductCarousel = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnCarouselItemReselect,
    handleOnCarouselItemDelete,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  } = ResponsiveProductCarouselFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ResponsiveCarouselAdaptor,
    props: {
      onItemReselect: handleOnCarouselItemReselect,
      onItemSort: handleOnCarouselItemSort,
      onItemDelete: handleOnCarouselItemDelete,
      onStaticChange: handleOnCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
    },
  };
};
export { generateResponsiveProductCarousel };
